import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: 'landing-page',
        loadChildren: () => import('./features/landing-page/landing-page.module').then((m) => m.LandingPageModule),
    },
    {
        path: 'details-wedding',
        loadChildren: () => import('./features/details-wedding/details-wedding.module').then((m) => m.DetailsWeddingModule),
    },
    {
        path: 'gallery',
        loadChildren: () => import('./features/gallery/gallery.module').then((m) => m.GalleryModule),
    },
    {
        path: 'json-generator',
        loadChildren: () => import('./features/json-generator/json-generator.module').then((m) => m.JsonGeneratorModule),
    },
    {
        path: '**',
        redirectTo: 'landing-page',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
